export function isSysAdmin(user) {
  return user?.role === 'sysadmin' || user?.role === 'sysadminRO'
}

export function isAdmin(user) {
  return user?.role === 'admin' || user?.role === 'adminRO' || isSysAdmin(user)
}
